import React from 'react';
import { CTAButton } from './CTAButton';
import { FileText, ShieldCheck, UserCheck } from 'lucide-react';
export function MethodSection() {
  return <section className="bg-brand-navy-light text-white py-16 md:py-24 px-4 border-y-4 border-brand-gold" data-id="element-42">
      <div className="max-w-4xl mx-auto text-center space-y-12" data-id="element-43">
        <div className="space-y-4" data-id="element-44">
          <span className="text-brand-gold font-bold tracking-widest uppercase text-sm" data-id="element-45">
            El Secreto Mejor Guardado
          </span>
          <h2 className="font-heading text-4xl md:text-5xl font-bold text-white leading-tight" data-id="element-46">
            Presentamos: El Método de la <br data-id="element-47" />
            <span className="text-brand-gold" data-id="element-48">
              "Carta de Disputa Emocional"
            </span>{' '}
            (MDE)
          </h2>
        </div>

        <p className="font-body text-xl text-gray-300 leading-relaxed max-w-3xl mx-auto" data-id="element-49">
          A diferencia de los métodos legales fríos que las computadoras de los
          burós ignoran, mi método utiliza una redacción específica diseñada
          para obligar a un "revisor humano" a mirar tu caso.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-left mt-12" data-id="element-50">
          <div className="bg-brand-navy p-8 rounded-xl border border-gray-700" data-id="element-51">
            <FileText className="w-12 h-12 text-brand-gold mb-6" data-id="element-52" />
            <h4 className="font-heading text-xl font-bold mb-4" data-id="element-53">
              Lenguaje FCRA
            </h4>
            <p className="font-body text-gray-400" data-id="element-54">
              Utilizamos el lenguaje exacto de la Ley Federal para exigir tus
              derechos legales.
            </p>
          </div>
          <div className="bg-brand-navy p-8 rounded-xl border border-gray-700" data-id="element-55">
            <UserCheck className="w-12 h-12 text-brand-gold mb-6" data-id="element-56" />
            <h4 className="font-heading text-xl font-bold mb-4" data-id="element-57">
              Narrativa Personal
            </h4>
            <p className="font-body text-gray-400" data-id="element-58">
              Activamos protocolos manuales al incluir una identidad personal
              innegable.
            </p>
          </div>
          <div className="bg-brand-navy p-8 rounded-xl border border-gray-700" data-id="element-59">
            <ShieldCheck className="w-12 h-12 text-brand-gold mb-6" data-id="element-60" />
            <h4 className="font-heading text-xl font-bold mb-4" data-id="element-61">
              Resultados Rápidos
            </h4>
            <p className="font-body text-gray-400" data-id="element-62">
              Aumenta drásticamente la probabilidad de eliminar cuentas
              negativas en 30 a 90 días.
            </p>
          </div>
        </div>

        <div className="pt-10" data-id="element-63">
          <CTAButton data-id="element-64">QUIERO USAR ESTE MÉTODO HOY</CTAButton>
        </div>
      </div>
    </section>;
}